<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause">
        <div>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:16px">
        <span style="font-family:'黑体'; font-weight:bold; font-size:16px">上海浦东发展银行借记卡章程</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:32pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:16px">
        <span style="font-family:'仿宋_GB2312'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第一章　总则</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第一条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">为有效地向社会各界提供优质银行卡服务，规范上海浦东发展银行各境内发卡机构（以下简称“发卡机构”）及持有上海浦东发展银行借记卡的客户（以下简称“持卡人”）的合法权益及义务，依据国家相关法律法规监管规定的规定，制定本章程。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第二条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">上海浦东发展银行借记卡（以下简称借记卡）是由发卡机构面向个人客户公开发行的、符合发卡机构已加入的相关银行卡清算机构（以下简称“银行卡清算机构”）发卡标准的人民币借记卡。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第三条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">联名卡（借记卡）是指经监管机关批准的，发卡机构与合作机构（联名单位）联合发行的借记卡附属产品。联名卡（借记卡）适用本章程，但另有约定的除外。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第二章</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">申卡和销卡</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第四条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">境内外自然人均可根据需要申请借记卡。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第五条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">申请借记卡须遵照个人账户实名制相关要求，根据国家法律法规监管规定提供相应的身份证件及发卡机构要求的其他验证信息，保证其向发卡机构提供的所有申请资料均真实、完整、有效、合法。符合非中国税收居民标准的，还应按照国家法律法规监管规定，提供本人税收居民身份相关信息。</span><span
          style="font-family:'宋体'; font-weight:bold">申请人确认自愿遵守本章程与《上海浦东发展银行借记卡服务协议》（以下简称《服务协议》）及其后之修订版本。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">因办理借记卡所需，</span><span
          style="font-family:'宋体'">申请人同意发卡机构可根据法律法规监管规定和申请人授权查询、获取持卡人的信息，并对申请人身份资料等信息进行审核，审核通过后为申请人办理借记卡。</span><span
          style="font-family:'宋体'">申请人知晓并同意如</span><span style="font-family:'宋体'">审核不通过的</span><span
          style="font-family:'宋体'">，</span><span style="font-family:'宋体'">申请资料</span><span
          style="font-family:'宋体'">无需</span><span style="font-family:'宋体'">退还申请人。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第六条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">基于保障持卡人享有必要的借记卡服务及配合发卡机构履行反洗钱等职责之目的，</span><span
          style="font-family:'宋体'">发卡机构有权根据国家法律法规、监管要求对客户开展必要的尽职调查工作，</span><span style="font-family:'宋体'">如</span><span
          style="font-family:'宋体'">不予配合，或</span><span style="font-family:'宋体'">持卡人提供的</span><span
          style="font-family:'宋体'">身份证明证件、</span><span style="font-family:'宋体'">通讯地址、联系电话、住址、职业等资料或信息发生变</span><span
          style="font-family:'宋体'">化时，应及时通过发卡机构渠道办理信息变更手续，对于未及时完成上述变更手续的，</span><span
          style="font-family:'宋体'">发卡机构有权暂停或终止借记卡的使用和相关服务，由此产生的经济损失和法律责任应由持卡人承担。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; font-size:10.5pt">
        <span style="font-family:'宋体'">第七条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">持卡人需要停止使用借记卡，可向发卡机构申请销卡。销卡前持卡人应还清全部交易款项和有关费用。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第三章　基础功能</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第八条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">持卡人可以以借记卡为载体开立一个或多个银行账户。备用金账户是借记卡默认开通的人民币</span><span
          style="font-family:'宋体'">银行结算</span><span style="font-family:'宋体'">账户。</span><span
          style="font-family:'宋体'">持卡人使用借记卡进行的交易，如未特别指明，将默认借记</span><span style="font-family:'等线'">/</span><span
          style="font-family:'宋体'">贷记至人民币</span><span style="font-family:'宋体'">银行结算</span><span
          style="font-family:'宋体'">账户。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第九条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">根据等级不同，借记卡分为普卡、金卡、白金卡和钻石卡，</span><span
          style="font-family:'宋体'">客户可根据申领条件的不同申请对应等级的借记卡。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">具有</span><span
          style="font-family:'宋体'">存款、取款、银联渠道的POS消费、消费撤销、预授权类交易、查询对账等业务功能。持卡人可根据需要签约办理</span><span
          style="font-family:'宋体'">电子渠道的</span><span
          style="font-family:'宋体'">转账汇款、基金、投资理财、外汇买卖、第三方存管、贵金属、贷款等其他功能</span><span
          style="font-family:'宋体'">。借记卡不具备透支功能。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十一条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">根据借记卡介质形态不同，借记卡分为电子卡和实体卡两种形态。对于建立借记卡卡号但未配置实体卡的为电子借记卡；对于建立借记卡卡号且配置了实体卡的为实体借记卡。电子借记卡可通过电子渠道用卡，实体借记卡除电子渠道外还可通过实体卡受理终端使用借记卡相关功能。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第四章　交易及验证</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十二条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">持卡人开立借记卡时</span><span style="font-family:'宋体'">可以</span><span
          style="font-family:'宋体'">设定交易密码。持卡人应妥善保管和正确使用</span><span
          style="font-family:'宋体'">手机号码、动态验证码、客户身份信息、数字证书、生物识别</span><span style="font-family:'宋体'">等个人交易验证信息</span><span
          style="font-family:'宋体'">和手机等个人设备终端</span><span style="font-family:'宋体'">，不将密码</span><span
          style="font-family:'宋体'">等</span><span style="font-family:'宋体'">前述</span><span
          style="font-family:'宋体'">个人交易信息</span><span
          style="font-family:'宋体'">告知或泄露给他人。借记卡密码遗失的，持卡人应凭本人有效身份证件及时向发卡机构办理密码重置。持卡人应在技术和商户环境安全的前提下通过移动通讯设备和互联网（</span><span
          style="font-family:'等线'">INTERNET</span><span style="font-family:'宋体'">）等使用借记卡。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第十三条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">持卡人同意并理解，根据法律法规监管规定以及发卡机构与持卡人的约定，发卡机构凭交易密码和</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">或其他认证要素（如</span><span
          style="font-family:'宋体'; font-weight:bold">手机号码、</span><span
          style="font-family:'宋体'; font-weight:bold">动态</span><span
          style="font-family:'宋体'; font-weight:bold">验证码</span><span
          style="font-family:'宋体'; font-weight:bold">、客户身份信息、生物识别等）对交易真实性予以核实并提供服务。因密码和</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">或其他认证要素（包括</span><span
          style="font-family:'等线'; font-weight:bold">U-KEY</span><span
          style="font-family:'宋体'; font-weight:bold">等账户存取工具和安全认证工具）保管、使用不当而发生交易的，仍视同持卡人的本人授权，持</span><span
          style="font-family:'宋体'; font-weight:bold">卡人应承担相关责任与义务。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">凭借记卡磁条、芯片、设备卡、卡号或密码等电子数据办理的各项交易（包括但不限于通过</span><span
          style="font-family:'等线'">POS</span><span
          style="font-family:'宋体'">终端、电话、手机、短信、互联网等方式进行的借记卡交易）所产生的电子信息记录及交易凭证均为该项交易的有效凭据，并作为正式记账凭证。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第五章　收费</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十四条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">发卡机构根据国家法律法规监管规定制定借记卡服务收费项目和收费标准。借记卡收费标准以发卡机构通过营业网点或发卡机构网站或官方微信等渠道最新公布的服务价格目录为准。持卡人申请借记卡即视同接受借记卡收费标准，须按发卡机构规定的收费标准和缴费方式缴纳相关费用。若持卡人未按规定缴纳费用，发卡机构有权中止提供相应服务。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第六章　用卡安全</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十五条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">须按照法律法规监管规定申请和开立，</span><span
          style="font-family:'宋体'">只限持卡人本人使用，</span><span style="font-family:'宋体'">若发生出租、出借、出售、转让（包括</span><span
          style="font-family:'等线'">U-KEY</span><span
          style="font-family:'宋体'">等账户存取工具和安全认证工具）等，或冒领或冒用银行卡等行为，发卡机构有权按照国家法律法规监管要求要求，暂停或终止借记卡的使用及相关服务，并有权依法追究持卡人法律责任</span><span
          style="font-family:'宋体'">。</span><span style="font-family:'宋体'">发卡机构不承担因上述行为引起的损失或责任。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十六条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">持卡人不得参与或协助参与洗钱等违反国家法律法规监管规定的交易，发卡机构有权按照国家法律法规</span><span
          style="font-family:'宋体'">或</span><span style="font-family:'宋体'">监管规定，采取主动锁定、</span><span
          style="font-family:'宋体'">降低交易额度、</span><span
          style="font-family:'宋体'">限制非柜面交易、销卡等控制措施，暂停或终止借记卡的使用及相关服务，保留依法追究持卡人法律责任的权利。发卡机构不承担因上述行为引起的损失或责任。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第十七条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span
          style="font-family:'宋体'; font-weight:bold">对于疑似具有伪卡盗用、卡片敏感信息泄露等较高风险的交易，为防范发生资金损失，持卡人同意发卡机构视情况采取拒绝承兑该笔交易或主动锁定、限制非柜面交易等临时控制措施，并在向持卡人核实后协助予以解除控制。发卡机构不承担因上述行为引起的损失或责任。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第十八条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">对于</span><span
          style="font-family:'宋体'; font-weight:bold">超过</span><span
          style="font-family:'等线'; font-weight:bold">1</span><span
          style="font-family:'宋体'; font-weight:bold">年及以上</span><span
          style="font-family:'宋体'; font-weight:bold">无任何账务交易的、备用金账户余额和应计未计利息数为零也未开通理财</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">基金</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">保险</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">第三方存管</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">个人贷款还款等业务</span><span
          style="font-family:'宋体'; font-weight:bold">、</span><span
          style="font-family:'宋体'; font-weight:bold">且未销卡</span><span
          style="font-family:'宋体'; font-weight:bold">的借记卡（</span><span
          style="font-family:'宋体'; font-weight:bold">简称</span><span
          style="font-family:'宋体'; font-weight:bold">“双零卡”），</span><span
          style="font-family:'宋体'; font-weight:bold">为了持卡人账户安全，发卡机构有权通过持卡人在持卡机构预留的方式通知持卡人到发卡机构营业网点重新办理账户身份核实手续。</span><span
          style="font-family:'宋体'; font-weight:bold">如</span><span
          style="font-family:'宋体'; font-weight:bold">持卡人拒不配合的，发卡机构可停止该卡的金融服务并销户。</span><span
          style="font-family:'宋体'; font-weight:bold">发卡机构不承担因上述行为引起的损失或责任。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第十九条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">根据国家法律法规监管规定，持卡人</span><span
          style="font-family:'宋体'; font-weight:bold">开卡之日起六个月内无交易记录的账户，或持卡人</span><span
          style="font-family:'宋体'; font-weight:bold">连续三年以上（含三年）未发生存现、取现、转账等主动交易，</span><span
          style="font-family:'宋体'; font-weight:bold">且</span><span
          style="font-family:'宋体'; font-weight:bold">无信用卡约定还款、个人贷款还款、理财等签约关系，且账户余额低于</span><span
          style="font-family:'等线'; font-weight:bold">100</span><span
          style="font-family:'宋体'; font-weight:bold">元的借记卡账户，</span><span
          style="font-family:'宋体'; font-weight:bold">发卡机构有权暂停借记卡非柜面业务，待持卡人配合重新核实身份后，予以恢复借记卡功能及业务。</span><span
          style="font-family:'宋体'; font-weight:bold">发卡机构不承担</span><span
          style="font-family:'宋体'; font-weight:bold">因上述行为引起的损失或责任。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第二十条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">对于不符合监管规定开立的借记卡、违反本人意愿使用的借记卡</span><span
          style="font-family:'宋体'; font-weight:bold">、</span><span
          style="font-family:'宋体'; font-weight:bold">或存在其他</span><span
          style="font-family:'宋体'; font-weight:bold">涉及洗钱</span><span
          style="font-family:'宋体'; font-weight:bold">风险隐患的借记卡</span><span
          style="font-family:'宋体'; font-weight:bold">，发卡机构在</span><span
          style="font-family:'宋体'; font-weight:bold">通过</span><span
          style="font-family:'宋体'; font-weight:bold">公</span><span
          style="font-family:'宋体'; font-weight:bold">告或</span><span
          style="font-family:'宋体'; font-weight:bold">短信等方式</span><span
          style="font-family:'宋体'; font-weight:bold">通知持卡人到发卡机构营业网点重新</span><span
          style="font-family:'宋体'; font-weight:bold">进行尽职调查</span><span
          style="font-family:'宋体'; font-weight:bold">。</span><span
          style="font-family:'宋体'; font-weight:bold">如</span><span
          style="font-family:'宋体'; font-weight:bold">持卡人拒不配合的，发卡机构可停止该卡的金融服务并销户。</span><span
          style="font-family:'宋体'; font-weight:bold">发卡机构不承担因上述行为引起的损失或责任。销卡时将账户余额及应付利息转至本行久悬户。客户可凭本人有效身份证件或借记卡实体卡到本行营业网点领取现金。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">因被他人冒用身份信息开立或代理开立借记卡的，经发卡机构对持卡人有效身份识别、调查后，发卡机构</span><span
          style="font-family:'宋体'; font-weight:bold">终止</span><span
          style="font-family:'宋体'; font-weight:bold">相关借记卡的使用并办理销卡，卡内资金按照国家法律法规监管规定列入久悬专户管理。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'; font-weight:bold">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第七章　附则</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第二十一条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">本章程由上海浦东发展银行负责制定</span><span style="font-family:'等线'">,</span><span
          style="font-family:'宋体'">并在经报中国银行业监督管理机构备案后生效实施。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span
          style="font-family:'宋体'">上海浦东发展银行有权根据国家法律法规监管规定以及经营需要修改本章程及相关服务（包括收费标准等）内容，在报中国银行保险监督管理机构备案后，在发卡机构的营业网点、网站或监管机关要求的其他渠道进行公告。公告期满后，修改后的章程即对持卡人有约束力，无须另行通知持卡人。在公告期内，持卡人可选择是否继续使用借记卡及相关服务。若持卡人不愿接受公告内容的，可在公告内容正式实施前通过发卡机构渠道办理销卡。公告期满持卡人未办理销卡的，即视为同意接受公告的各项内容。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第二十二条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">除双方另有约定外，就</span><span style="font-family:'宋体'">本章程未尽事宜，按照国家法律法规监管规定执行。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold; background-color:#ffffff">第二十三条&nbsp;&nbsp;</span><span
          style="font-family:'宋体'; font-weight:bold; background-color:#ffffff"> </span><span
          style="font-family:'宋体'; font-weight:bold; background-color:#ffffff">如客户对本章程或发卡机构提供的借记卡服务有任何疑问、意见或建议，可通过拨打</span><span
          style="font-family:Calibri; font-weight:bold; background-color:#ffffff">955</span><span
          style="font-family:Calibri; font-weight:bold; background-color:#ffffff">28</span><span
          style="font-family:'宋体'; font-weight:bold; background-color:#ffffff">客户服务热线咨询、投诉与反映。</span></p>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pufaAccountAgreement',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 24px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
.table{
  margin: 20px 10px;
}
</style>
